import { render } from "./d2c_return_approval.vue?vue&type=template&id=d5360214&scoped=true"
import script from "./d2c_return_approval.vue?vue&type=script&lang=js"
export * from "./d2c_return_approval.vue?vue&type=script&lang=js"

import "./d2c_return_approval.vue?vue&type=style&index=0&id=d5360214&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5360214"]])

export default __exports__